// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__GUf3l"};